import { Component, Input } from '@angular/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-pnr',
  styleUrls: ['./pnr.component.scss'],
  templateUrl: './pnr.component.html'
})
export class PnrComponent {
  @Input() public pnr = '';
  @Input() public supplierName = '';
}
